import * as types from "./actionTypes";
import * as apiUrls from "./apiUrls";
import { BaseApi } from "../shared/api";

export function fetchCompany(onSuccess = () => {}) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user } = getState();

    dispatch({type: types.COMPANY_FETCH});
    return api.getRequest(
      apiUrls.companies(user.id),
      response => {
        dispatch({
          type: types.COMPANY_RECEIVE,
          payload: response.data[0],
        });
        onSuccess();
      }
    )
  }
}

export function updateCompany(body, callback) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user, company } = getState();

    return api.putRequest(
      apiUrls.company(user.id, company.id),
      body,
      response => {
        callback(response);
      }
    )
  }
}

export function hydrateCompany(payload) {
  return {
    type: types.COMPANY_HYDRATE,
    payload: payload
  }
}


export function updateCompanyEmail(body, callback) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user, company } = getState();

    return api.postRequest(
      apiUrls.companyEmailUpdate(user.id, company.id),
      body,
      response => {
        callback(response);
      }
    )
  }
}

export function confirmCompanyEmail(body, callback) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);
    const { user, company } = getState();

    return api.putRequest(
      apiUrls.companyEmailUpdateConfirmation(user.id, company.id),
      body,
      response => {
        callback(response);
      }
    )
  }
}

// dataPoints actions

export function fetchDataPoint(type) {
  return (dispatch, getState) => {
    const api = new BaseApi(dispatch, getState);

    dispatch({type: types.DATA_POINT_FETCH});
    return api.getRequest(
      apiUrls.dataPoint(type),
      response => {
        dispatch({type: types.DATA_POINT_RECEIVE, payload: { data: response.data, type: type }});
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/company/actions.js